import { Skeleton } from '@bliks-io/ui';
import { Header } from '@/layout/header/Header';

const CHECKLIST_WIDTHS = ['w-72', 'w-64', 'w-80', 'w-60'];

/**
 * Loading placeholder shaped like the wizard's first (intro) page — app Header,
 * a centred welcome block, and the footer's primary button — so entering the
 * wizard doesn't flash a bare spinner before the full chrome appears. Mirrors
 * the intro layout of WizardShell + WelcomeStep.
 */
export function WizardIntroSkeleton() {
  return (
    <div className="flex h-screen flex-col">
      <Header />

      <div className="flex min-h-0 flex-1">
        <div className="flex min-w-0 flex-1 flex-col bg-white">
          <div className="min-h-0 flex-1 overflow-y-auto">
            <div className="flex min-h-full flex-col justify-center px-16 py-12">
              <Skeleton className="mx-auto mb-12 h-11 w-[520px]" />
              <div className="mx-auto grid max-w-[1080px] grid-cols-[440px_minmax(0,1fr)] items-center gap-16">
                <Skeleton className="h-[380px] w-[440px] rounded-full" />
                <div>
                  <Skeleton className="mb-3.5 h-7 w-64" />
                  <Skeleton className="mb-2 h-4 w-full max-w-[56ch]" />
                  <Skeleton className="mb-[22px] h-4 w-4/5 max-w-[56ch]" />
                  <Skeleton className="mb-3 h-4 w-40" />
                  <div className="flex flex-col gap-2.5">
                    {CHECKLIST_WIDTHS.map((width) => (
                      <Skeleton key={width} className={`h-4 ${width}`} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-between border-t border-line bg-white px-10 py-4">
            <div />
            <Skeleton className="h-10 w-32" />
          </div>
        </div>
      </div>
    </div>
  );
}
